// pipelines/kept-picture.ts
//
// A PICTURE THE TEAM PUT THERE STAYS.
//
// When one of a team's own saved slides is used as a template for new
// content, its logos and the pictures the team uploaded are kept (Dawid,
// 2026-10-13: "Keep logos & yours"). Such a picture carries this mark while
// the slide is built: it is not an image target, so no brief, search or
// repair replaces it, and the mark is taken off before the slide is inserted
// (see ../add-slide/own-pictures).

export const KEEP_MARK = "__aiKeep";

export const isKeptPicture = (
  settings: Record<string, unknown> | null | undefined,
): boolean => settings?.[KEEP_MARK] === true;
